/** --------------------------------------------------------
* Author Tien Tran
* Email tientran0019@gmail.com
* Phone 0972970075
*
* Created: 2024-08-09 22:30:47

* Last updated on: 2024-08-09 22:30:47
* Last updated by: Tien Tran
*------------------------------------------------------- */

"use client";

import React, { ReactNode } from "react";
import StickyBox from "react-sticky-box";

import {
	Stack,
	NoSsr,
	Container,
	Typography,
	ContainerProps,
	IconButton,
} from "@mui/material";
import { Iconify } from "@onair/minimal-ui/iconify";

type PropTypes = ContainerProps & {
	title?: string;
	subTitle?: string;
	actions?: ReactNode | ReactNode[];
	top?: ReactNode | ReactNode[];
	sticky?: ReactNode | ReactNode[];
	children?: ReactNode | ReactNode[];
	fullWidth?: boolean;
	className?: string;
	onBack?: () => void;
};

export const PageWrapper: React.FC<PropTypes> = (props) => {
	const {
		title,
		subTitle,
		actions,
		top,
		sticky,
		children,
		fullWidth = false,
		className,
		onBack,
		...others
	} = props;

	let containerProps: ContainerProps = {};
	if (fullWidth) {
		containerProps = { ...containerProps, maxWidth: false };
	}
	return (
		<Stack my={3} flex={1} className={className}>
			<Container component="div" {...containerProps} {...others}>
				<Stack
					justifyContent="space-between"
					spacing={1}
					sx={{
						flexDirection: {
							md: "row",
							xs: "column",
						},
						alignItems: {
							// md: "center",
							xs: "flex-start",
						},
					}}
					// className="flex flex-start flex-col md:flex-row"
				>
					{onBack ? (
						<IconButton onClick={onBack}>
							<Iconify icon={"solar:arrow-left-outline"} />
						</IconButton>
					) : null}
					{title && (
						<Stack flex={1} spacing={1}>
							<Typography sx={{ typography: "h4" }}>{title}</Typography>
							{subTitle && (
								<Typography variant="subtitle2">{subTitle}</Typography>
							)}
						</Stack>
					)}
					{actions}
				</Stack>
				{top}
			</Container>
			{sticky && (
				<NoSsr>
					<StickyBox offsetTop={60} offsetBottom={20} style={{ zIndex: 9 }}>
						<Container
							component="div"
							sx={{ bgcolor: "#fff", pt: "15px" }}
							{...containerProps}
							{...others}
						>
							{sticky}
						</Container>
					</StickyBox>
				</NoSsr>
			)}
			<Container component="div" sx={{ mt: 3 }} {...containerProps} {...others}>
				{children}
			</Container>
		</Stack>
	);
};
